<template>
	<div class="d-flex flex-row align-content-center px-0">
		<botao-tooltip
			icone="mdi-pencil"
			cor="grey"
			texto="Editar"
			@click="abrirModalEditar"
			v-az-auth="permissoes.tipoDocumentoEditar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-arrow-decision-outline"
			cor="grey"
			texto="Validação de Tramitação"
			@click="abrirModalValidacaoTramitacao"
			v-az-auth="permissoes.tipoDocumentoValidacaoTramitacaoListar"
		></botao-tooltip>
		<botao-tooltip
			icone="mdi-delete"
			cor="grey"
			texto="Excluir"
			@click="abrirModalExcluir"
			v-az-auth="permissoes.tipoDocumentoExcluir"
		></botao-tooltip>
	</div>
</template>

<script>
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'tipo-documento-listagem-botoes-acoes',
	components: { BotaoTooltip },
	props: {
		idTipoDocumento: {
			type: Number,
			required: true,
		},
	},
	methods: {
		abrirModalEditar() {
			this.$emit('abrir-modal-editar')
		},
		abrirModalExcluir() {
			this.$emit('abrir-modal-excluir', this.idTipoDocumento)
		},
		abrirModalValidacaoTramitacao() {
			this.$emit('abrir-modal-validacao-tramitacao', this.idTipoDocumento)
		},
	},
}
</script>

<style scoped lang="stylus"></style>
